import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Calendar as CalendarIcon, Guitar } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';
import api from '@/lib/api';
import { PublicHeader, PublicFooter } from '@/components/PublicShell';
import { StageStatusBadge, formatDatePt } from '@/components/Badges';

export default function CalendarPage() {
  const [stages, setStages] = useState([]);
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    api.get('/public/stages').then((r) => setStages(r.data));
    api.get('/public/settings').then((r) => setSettings(r.data));
  }, []);

  // Group by month
  const groups = {};
  stages.forEach((s) => {
    const d = new Date(s.date + 'T12:00:00');
    const key = d.toLocaleDateString('pt-BR', { month: 'long', year: 'numeric' });
    if (!groups[key]) groups[key] = [];
    groups[key].push(s);
  });

  return (
    <div>
      <PublicHeader />
      <div className="mx-auto max-w-6xl px-4 sm:px-6 py-10">
        <div className="flex items-center gap-3 mb-2">
          <CalendarIcon className="w-6 h-6 text-[var(--g66-amber)]" />
          <div className="font-display text-4xl text-white">CALENDÁRIO DE DISPUTAS</div>
        </div>
        <p className="text-muted-foreground">Todas as etapas do Campeonato de Bandas.</p>

        {Object.keys(groups).length === 0 ? (
          <div className="text-center py-16 text-muted-foreground">Nenhuma etapa cadastrada.</div>
        ) : (
          <div className="mt-8 space-y-8">
            {Object.entries(groups).map(([month, list]) => (
              <div key={month}>
                <div className="font-display text-2xl text-[var(--g66-amber)] uppercase mb-3">{month}</div>
                <div className="space-y-3">
                  {list.map((s) => (
                    <Link key={s.id} to={`/etapas/${s.slug}`} className="block" data-testid={`stage-item-${s.slug}`}>
                      <Card className="card-hover border border-border bg-card">
                        <CardContent className="p-5 grid grid-cols-1 sm:grid-cols-[auto_1fr_auto] gap-4 items-center">
                          <div className="text-center min-w-[70px]">
                            <div className="font-display text-3xl text-white">{new Date(s.date + 'T12:00:00').getDate().toString().padStart(2, '0')}</div>
                            <div className="text-xs text-muted-foreground uppercase">{new Date(s.date + 'T12:00:00').toLocaleDateString('pt-BR', { month: 'short' }).replace('.', '')}</div>
                          </div>
                          <div className="min-w-0">
                            <div className="text-xs text-muted-foreground">{s.type} • {s.start_time || '21:00'}</div>
                            <div className="font-semibold text-white">{s.title}</div>
                            <div className="text-sm text-muted-foreground mt-1 flex flex-wrap items-center gap-x-2 gap-y-1">
                              <span className="inline-flex items-center gap-1"><Guitar className="w-3 h-3" />{s.band_a?.name || 'A definir'}</span>
                              {s.bands_count === 3 ? (
                                <>
                                  <span className="text-[var(--g66-red)] font-medium">·</span>
                                  <span className="inline-flex items-center gap-1"><Guitar className="w-3 h-3" />{s.band_b?.name || 'A definir'}</span>
                                  <span className="text-[var(--g66-red)] font-medium">·</span>
                                  <span className="inline-flex items-center gap-1"><Guitar className="w-3 h-3" />{s.band_c?.name || 'A definir'}</span>
                                </>
                              ) : (
                                <>
                                  <span className="text-[var(--g66-red)] font-medium">VS</span>
                                  <span className="inline-flex items-center gap-1"><Guitar className="w-3 h-3" />{s.band_b?.name || 'A definir'}</span>
                                </>
                              )}
                            </div>
                          </div>
                          <div className="flex flex-col items-end gap-2">
                            <StageStatusBadge status={s.status} />
                            {s.status === 'finished' && s.winner_band && (
                              <div className="text-xs text-[var(--g66-amber)]">Vencedora: {s.winner_band.name}</div>
                            )}
                          </div>
                        </CardContent>
                      </Card>
                    </Link>
                  ))}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
      <PublicFooter settings={settings} />
    </div>
  );
}
